import { Component } from '@angular/core'
import { faCircle } from '@fortawesome/free-solid-svg-icons'
import { faTelegramPlane, faViber, faWhatsapp } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'

@Component({
  selector: 'app-logo-messenger-icon',
  template: `
    <div class="icon-wrapper">
      <fa-icon [icon]="backgroundCircleIcon"></fa-icon>
      <fa-icon [icon]="whatsappIcon"></fa-icon>
      <fa-icon class="whatsapp" [icon]="whatsappIcon"></fa-icon>
      <fa-icon [icon]="backgroundCircleIcon"></fa-icon>
      <fa-icon [icon]="viberIcon"></fa-icon>
      <fa-icon class="viber" [icon]="viberIcon"></fa-icon>
      <fa-icon [icon]="backgroundCircleIcon"></fa-icon>
      <fa-icon class="telegram" [icon]="telegramIcon"></fa-icon>
    </div>
  `,
  styleUrls: ['./logo-messenger-icon.component.scss'],
  imports: [FontAwesomeModule],
  standalone: true
})
export class LogoMessengerIconComponent {
  protected readonly backgroundCircleIcon = faCircle;
  protected readonly telegramIcon = faTelegramPlane;
  protected readonly viberIcon = faViber;
  protected readonly whatsappIcon = faWhatsapp;
}
